import { createClient } from "@supabase/supabase-js";

const hfVariables =
  typeof window !== "undefined" ? window.huggingface?.variables : undefined;

export const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || hfVariables?.VITE_SUPABASE_URL || "";

export const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  hfVariables?.VITE_SUPABASE_ANON_KEY ||
  "";

export const isSupabaseConfigured = Boolean(
  supabaseUrl && supabasePublishableKey,
);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabasePublishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
